import { Events, Events_Filter } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const eventAgendaGqlQuery: GqlFragment<
  { events: Events[] },
  { filters: Events_Filter }
> = gql`
  query EventAgenda($filters: events_filter) {
    events(filter: $filters) {
      translations {
        agendaDescription
        languages_code {
          code
        }
      }
      subEvents {
        id
        guestLimit
        requireRegistration
        eventTimeslots {
          id
          startDate
          endDate
          eventParticipants_func {
            count
          }
        }
        speakers {
          people_id {
            name
            avatar {
              id
            }
          }
        }
        translations {
          title
          location
          description
          languages_code {
            code
          }
        }
      }
    }
  }
`;
